function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M22.245 17.1875L12.8739 0.9375C12.1552 -0.3125 10.3466 -0.3125 9.62395 0.9375L0.252855 17.1875C-0.465894 18.4336 0.432543 20 1.87786 20H20.6239C22.0614 20 22.9677 18.4375 22.245 17.1875ZM11.9404 6.25H10.5537C10.4208 6.25 10.3154 6.35938 10.3193 6.49219L10.6122 14.1484C10.6162 14.2773 10.7216 14.375 10.8466 14.375H11.6474C11.7724 14.375 11.8779 14.2734 11.8818 14.1484L12.1747 6.49219C12.1787 6.35938 12.0732 6.25 11.9404 6.25ZM10.1553 16.25C10.1553 15.6445 10.6436 15.1562 11.249 15.1562C11.8545 15.1562 12.3428 15.6445 12.3428 16.25C12.3428 16.8555 11.8545 17.3438 11.249 17.3438C10.6436 17.3438 10.1553 16.8555 10.1553 16.25ZM1.87391 18.75H20.6239C21.1044 18.75 21.4052 18.2266 21.163 17.8125L11.788 1.56254C11.5497 1.14457 10.9442 1.14848 10.7059 1.56254L1.33094 17.8125C1.09266 18.2305 1.39344 18.75 1.87391 18.75Z",
  fill: "current"
});

function SvgWarningOutlined(_ref, svgRef) {
  let title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 20,
    viewBox: "0 0 23 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarningOutlined);
export default __webpack_public_path__ + "static/media/warning_outlined.034c20df.svg";
export { ForwardRef as ReactComponent };